import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { validateSession } from '../utils/authUtils';
import LoadingOverlay from './LoadingOverlay';

/**
 * A component that protects routes by validating the authentication token before rendering
 * Redirects to auth page if token is invalid
 */
const ProtectedRoute = ({ children }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const validateAuth = async () => {
      setIsValidating(true);
      try {
        const isSessionValid = await validateSession();
        setIsValid(isSessionValid);
      } catch (error) {
        console.error('Error validating session:', error);
        setIsValid(false);
      } finally {
        setIsValidating(false);
      }
    };

    validateAuth();
  }, [location.pathname]);

  if (isValidating) {
    return <LoadingOverlay message="Validating session..." />;
  }

  if (!isValid) {
    // Redirect to auth page with current path as return URL
    return <Navigate to={`/auth?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
